import { useState, useEffect } from 'react';
import { Button, Card, Input, message, Modal, Table, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import validator from 'validator';
import SearchBox from '../../components/SearchBox';
import { Tooltip } from "antd";
import CreateUsers from '../../pages/createUser';
import UserInfo from '../../components/userInfo';
import useFetch from '../../_fetch';
import { user_role, user_status } from '../../consts';
import { useGetAllUsers } from '../../utils/queryUtils';
import { setReloadUser } from '../../store/action/reload';
import { useParams } from 'react-router-dom';

export default function FirmUsers() {
    let dispatch = useDispatch();
    const { role } = useSelector(st => st.user);
    const { name: companyName } = useParams();
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState('');
    const [showResetPassword, setShowResetPassword] = useState();
    const [show, setShow] = useState([]);
    const placeholder = "Search Users..."
    const [resetPassword, setResetPssword] = useState();
    const [tableFilters, setTableFilters] = useState({});
    const { reloadUser } = useSelector(st => {
        return st.reload
    })
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const [currentPage, setCurrentPage] = useState(1);

    const allUserWithinCache = useGetAllUsers(currentPage, tableFilters, companyName);
    const all = allUserWithinCache?.data?.data;
    const _fetch = useFetch();
    useEffect(() => {
        console.log(all)
        setShow(all);
    }, [all])

    function selectUser(id) {
        setSelectedUser(id);
        setShowModal(true);
    }

    function CloseModal() {
        setShowModal(false);
        setSelectedUser(null);
    }


    const passwordValidator = () => {
        return validator.isStrongPassword(resetPassword);
    }

    const functionFilter = Object.keys(user_role).map((e) => ({ text: e, value: e }))
    const statusFilter = Object.keys(user_status).map((e) => ({ text: e, value: e }))

    const handleTableChange = (pagination, filters) => {
        setCurrentPage(pagination.current);
        const newFilters = {};
        newFilters.role = filters.role;
        newFilters.status = filters.status;
        setTableFilters((prev) => {
            return { ...prev, ...newFilters }
        });
    };

    async function handleResetPassword() {

        if (!passwordValidator()) {
            message.error("Password must be 8 characters long, with at least one uppercase, one lowercase, one number and one symbol");
            return;
        }

        let res = await _fetch(`${process.env.REACT_APP_API_URL}/user/update/password`, {
            method: "PATCH",
            body: {
                new_password: resetPassword,
                user_id: showResetPassword
            }
        })
        let result = await res.json();
        if (res.status === 200) {
            setShowResetPassword();
            setResetPssword();
            message.success("Password reset successfully");
        } else {
            setResetPssword();
            message.error(result.response);
        }
    }

    const columns = [
        {
            title: "USER",
            key: "name",
            width: "25%",
            render: (record) => (
                <UserInfo
                    firstName={record.first_name}
                    lastName={record.last_name}
                    avatraProps={{ size: 40, style: { backgroundColor: '#1890ff' } }}
                />
            )
        },
        {
            title: "Role",
            key: "role",
            width: "15%",
            render: (record) => {
                const companyNames = record?.company_ids?.map(e => e?.name)?.join(", ");
                return (
                    <div className="author-info">
                        <h5>{record?.role}</h5>
                        <Tooltip title={companyNames} placement="top">
                            <p style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "150px",
                                display: "block"
                            }}>
                                {companyNames}
                            </p>
                        </Tooltip>
                    </div>
                );
            },
            filters: functionFilter,
        },
        {
            title: "STATUS",
            key: "status",
            width: "15%",
            dataIndex: "status",
            filters: statusFilter,
        },
        {
            title: "Created On",
            key: "createdAt",
            dataIndex: "createdAt",
            width: "15%",
            render: (text) => moment(text).format('DD MMM YYYY'),
        },
        {
            title: "",
            key: "action",
            width: "15%",
            render: (record) => (
                <div>
                    <Button type='text' onClick={(e) => {
                        e.stopPropagation()
                        setShowResetPassword(record?._id)
                    }}>Reset Password</Button>
                    <Button type='text' onClick={() => selectUser(record?._id)}>Edit</Button>
                </div>
            )
        }
    ];

    useEffect(() => {
        if (reloadUser) {
            allUserWithinCache.refetch()
            dispatch(setReloadUser(false));
        }
    }, [reloadUser])
    useEffect(() => {
        if (all) {
            setPagination((prev) => ({
                ...prev,
                current: allUserWithinCache?.data?.pagination?.current,
                total: allUserWithinCache?.data?.pagination?.total,
            }));
        }
    }, [currentPage, all]);
    return (
        <div>


            <Card
                variant="borderless"
                className="circle_box table_space"

                title={
                    <div className="d-flex justify-content-start">


                        <div className="flex-fill search d-flex">
                            <span className="me-3">{role !== user_role.STAFF ? "All Users" : "All Primary Clients"}</span>
                            <div className="d-flex flex-fill justify-content-center">
                                <SearchBox all={all} setshow={setShow} name={placeholder} setFilter={setTableFilters} filterKey={'first_name'} />
                            </div>
                        </div>
                    </div>
                }
                extra={<Button type='primary' onClick={() => setShowModal(true)}>{role !== user_role.STAFF ? "Add User" : "Add Primary Client"}</Button>}
            >
                {
                    <div className="table-responsive">
                        <Table
                            columns={columns}
                            dataSource={show?.map(e => ({ ...e, key: e._id }))}
                            pagination={{ ...pagination, showSizeChanger: false, }}
                            className="ant-border-space"
                            onChange={handleTableChange}

                        />
                    </div>
                }
            </Card>
            <CreateUsers
                show={showModal}
                setShow={CloseModal}
                selectedUser={show?.filter(data => data?._id === selectedUser)[0]?._id}
                setSelectedUser={setSelectedUser}
                company={companyName}
            />
            <Modal
                title="Reset Password"
                open={showResetPassword ? true : false}
                onCancel={() => {
                    setShowResetPassword()
                    setResetPssword()
                }
                }
                okText="Reset"
                onOk={() => handleResetPassword()}
            >
                <div>
                    <Typography.Text
                    >
                        New Password should be at least 8 character long and must contain at least 1 lowercase character, 1 upper case character, 1 numeric and 1 special symbol.
                    </Typography.Text>
                    <Input placeholder="*******" type='password'
                        className='my-2'
                        autoComplete="new-password"
                        name='resetpassword'
                        value={resetPassword}
                        onChange={(e) => {
                            e.stopPropagation()
                            setResetPssword(e.target.value)
                        }}
                    />
                </div>
            </Modal>
        </div>
    );
}
